import {log} from '@/utils/logger';

const BASE_URL = import.meta.env.VUE_APP_API_ROOT;
const BASE_HF_URL = import.meta.env.VUE_APP_API_ROOT_HF;

export default class BaseService {

	private mocked = false;

	private baseUrl(): string {
		return BASE_URL;
	}

	private hfBaseUrl(): string {
		return BASE_HF_URL;
	}

	private mockedBase(): string {
		return '/data/mocked';
	}

	protected isMocked(): boolean {
		return this.mocked || import.meta.env.VUE_APP_SERVICE_MOCK === 'true';
	}

	protected mock() {
		log.warn('Using mocked data services');
		this.mocked = true;
	}

	protected live() {
		log.warn('Using live data services');
		this.mocked = false;
	}

	/**
	 * Create an URL for the 'new' Java-based Rest API.
	 */
	protected url(resource: string): string {
		let baseUrl = this.baseUrl();
		let suffix = '';
		if (this.isMocked()) {
			baseUrl = this.mockedBase();
			suffix = '.json';
			resource = resource.split('?').slice(0, 1).join('');
		}
		return `${baseUrl}/${resource}${suffix}`;
	}

	/**
	 * Create an URL for the HF-PHP Rest API.
	 */
	protected hfUrl(resource: string): string {
		const baseUrl = this.isMocked() ? this.mockedBase() : this.hfBaseUrl();
		return `${baseUrl}/${resource}.json`;
	}
}
